import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import imagelogo from '../../images/eldc-logoBLK.png'
import { saveState } from '../../store/LocalStorage';
import * as authActions from '../../action/authActions';
import Background from '../../images/Login-bg.png'
import { get } from "lodash";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

const Signin = props => {

	// console.log("prop value", props)

	const [formData, setName] = useState({ username: "", Upassword: "" });
	const [showPassword, setShowPassword] = useState(false);
	const [step, setStep] = useState("login"); // "login" or "2fa"
	const [twoFACode, setTwoFACode] = useState("");
	const [loading, setLoading] = useState(false);


	// let formData = new FormData();

	const Loginsubmit = async (e) => {
		e.preventDefault();
		console.log("formData", formData)
		authActions.login(formData.username, formData.Upassword, setLoading); 
	};

	const handleChange = (e) => {
		setName({ ...formData, [e.target.name]: e.target.value });
	};

	const handleChecked = (e) => {
		console.log("checked value", e.target.checked == true ? 1 : 0)
	}

	var sectionStyle = {
		// width: "100%",

		backgroundImage: `url(${Background})`
		// backgroundImage: `url(${get(props, 'companyDefaults.homepageImage.Location') || Background})`
	};

	return (
		<>
			<div className="loginmain" style={sectionStyle}>
				<section className="ftco-section">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-lg-6 col-md-7">
								<div className="login-wrap">
									<div className="logo" style={{ margin: "0 auto 30px" }}>
										<a href="index.html">
											<img style={{ maxHeight: "150px", objectFit: "contain" }} src={imagelogo} alt="" />
										</a>
									</div>
									<div className="heading-sm">
										<h5>AI-Humans </h5>
										<p>Create your own cases with AI-enabled virtual humans</p>
									</div>
									<form action="#" className="signin-form" onSubmit={Loginsubmit}>
										<div className="form-group mb-5">
											<input
												type="text"
												className="form-control"
												name="username"
												value={formData.username}
												placeholder="username"
												onChange={handleChange}
												id="username"
												required
											/>
											<span className="user"><i className="fa-regular fa-user"></i></span>
										</div>
										<div className="form-group mb-4">
											<input
												id="password-field"
												type={showPassword ? "text" : "password"}
												name="Upassword"
												className="form-control"
												placeholder="Password "
												value={formData.Upassword}
												onChange={handleChange}
												required
											/>
											<span
												className={`fa fa-fw field-icon ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
												onClick={() => setShowPassword(!showPassword)}
												style={{
													position: "absolute",
													right: "15px",
													top: "50%",
													transform: "translateY(-50%)",
													cursor: "pointer",
												}}
											></span>
										</div>
										<div className="mb-4">
											<button
												type="submit"
												className="form-control submit px-3"
												style={{ backgroundColor: "#ffc63e", color: "#000" }}
												disabled={loading}
											>
												{loading ? (
													<>
														<span
															className="spinner-border spinner-border-sm me-2"
															role="status"
															aria-hidden="true"
														></span>
														Signing In...
													</>
												) : (
													"Sign IN"
												)}
											</button>
										</div>
										<div className="d-flex justify-content-between align-items-center">
											<div className="form-check">
												<label className="form-check-label" htmlFor="form2Example31">
													{/* <input
													  className="form-check-input me-2" 
													  type="checkbox" value=""
													  id="form2Example31" checked="" 
													  />  */}
													<input
														type="checkbox"
														className="form-check-input me-2"
														// onChange={(e) => handleChecked(e)}
														id="form2Example31"
														defaultChecked={false ? "checked" : ""}
													/>
													Remember Me
												</label>
											</div>
											{/* <a className="fg-pass" href="#">Forgot Password </a> */}
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	);
};

const mapStateToProps = state => {
	return {
		auth: state.auth,
		companyDefaults: state.companyDefaults,
	}
}

const mapDispatchToProps = dispatch => {
	return {
		authActions: bindActionCreators(authActions, dispatch)
	}
}

// Login = reduxForm({
//   form: 'loginform',
//   validate
// })(Login)
export default connect(mapStateToProps, mapDispatchToProps)(Signin);